module.exports = __webpack_public_path__ + "static/media/09_tn.5dc039d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/09_tn.jpg
// module id = 439
// module chunks = 0